import React, { ReactNode} from 'react'
import { Box, Button, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Case, Product, Sku } from '../../api/models'

interface ProductCardProps {
  item: Product
  sku?: Sku
  selectedCase?: Case
  selectCase?: (from: Case | Product, to: Case | Product) => void
  children?: ReactNode
}

export const ProductCard = (props: ProductCardProps) => {
  const { item, sku, selectedCase, selectCase, children } = props
  const Icon = item.icon
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.typeDisplay}
        </Typography>
        <Grid container>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SquID:</Box>
            </Grid>
            <Grid item>{item.guid}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Name:</Box>
            </Grid>
            <Grid item>{sku ? sku.productName : item.name }</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SKU:</Box>
            </Grid>
            <Grid item>{sku ? sku.sku : item.sku?.sku}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Cases:</Box>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant={selectedCase ? 'outlined' : 'contained'}
                onClick={() => {
                  if (selectCase && selectedCase) {
                    selectCase(selectedCase, item)
                  }
                }}
              >
                x1
              </Button>
              {item.cases?.map((productCase) => (
                <Button
                  key={productCase.guid}
                  size="small"
                  variant={selectedCase?.guid === productCase.guid ? 'contained' : 'outlined'}
                  onClick={() => {
                    if (selectCase && selectedCase?.guid !== productCase.guid) {
                      selectCase(item, productCase)
                    }
                  }}
                >
                  x{productCase.numUnits}
                </Button>
              ))}
            </Grid>
          </Grid>
          {children}
        </Grid>
      </CardContent>
    </Card>
  )
}
